import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Stack,
  Divider,
  IconButton
} from '@mui/material';
import {
  Home as HomeIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import landingTheme from '../theme/landingTheme';

const LandingFooter = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // Se non siamo nella landing page, naviga prima lì
    if (window.location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <Box sx={{ bgcolor: landingTheme.colors.bgDark, color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Colonna 1: Prodotto */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
              Prodotto
            </Typography>
            <Stack spacing={1.5}>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => navigate('/features')}
              >
                Funzionalità
              </Button>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => navigate('/pricing')}
              >
                Prezzi
              </Button>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => navigate('/register')}
              >
                Prova Gratuita
              </Button>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => navigate('/demo')}
              >
                Demo
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Roadmap
              </Button>
            </Stack>
          </Grid>

          {/* Colonna 2: Supporto */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
              Supporto
            </Typography>
            <Stack spacing={1.5}>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Centro Assistenza
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Guide & Tutorial
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Video Dimostrativi
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                FAQ
              </Button>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => scrollToSection('contact')}
              >
                Contatta Supporto
              </Button>
            </Stack>
          </Grid>

          {/* Colonna 3: Azienda */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
              Azienda
            </Typography>
            <Stack spacing={1.5}>
              <Button 
                sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }} 
                onClick={() => navigate('/about')}
              >
                Chi Siamo
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Blog
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Casi di Studio
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Carriere
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Partner
              </Button>
            </Stack>
          </Grid>

          {/* Colonna 4: Legale */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
              Legale
            </Typography>
            <Stack spacing={1.5}>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Privacy Policy
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Termini di Servizio
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Cookie Policy
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                GDPR
              </Button>
              <Button sx={{ color: 'white', justifyContent: 'flex-start', textTransform: 'none' }}>
                Conformità Sanitaria
              </Button>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />

        {/* Footer Bottom */}
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: { xs: 'center', md: 'flex-start' } }}>
              <HomeIcon sx={{ fontSize: 32 }} />
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Gestionale Anziani
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'rgba(255,255,255,0.7)' }}>
              © 2025 Reaktice S.r.l.s.<br />
              P.IVA: 07249190484 - Firenze, Italy
            </Typography>
            <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', color: 'rgba(255,255,255,0.5)', mt: 1 }}>
              Tutti i diritti riservati
            </Typography>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <IconButton sx={{ color: 'white' }} aria-label="Facebook">
                <FacebookIcon />
              </IconButton>
              <IconButton sx={{ color: 'white' }} aria-label="Twitter">
                <TwitterIcon />
              </IconButton>
              <IconButton sx={{ color: 'white' }} aria-label="LinkedIn">
                <LinkedInIcon />
              </IconButton>
              <IconButton sx={{ color: 'white' }} aria-label="Instagram">
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingFooter;
